import { useContext, useMemo } from 'react';
import useQueryParams from 'hooks/useQueryParams';
import { trimSearchString } from 'utils';
import SearchContext from '../Search.context';

const MAX_RECENT_SEARCHES = 5;

const useRecentSearches = () => {
  const { recentSearches } = useContext(SearchContext);

  const {
    params: { searchString },
  } = useQueryParams<{ searchString: string }>();

  const trimmedSearchString = useMemo(
    () => trimSearchString(searchString),
    [searchString],
  );

  return useMemo(
    () =>
      (recentSearches || [])
        .filter((search) => search !== trimmedSearchString)
        .slice(0, MAX_RECENT_SEARCHES),
    [recentSearches, trimmedSearchString],
  );
};

export default useRecentSearches;
